import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import LanguageToggle from '../../../components/LanguageToggle';

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isHome = location.pathname === '/';
  const isAr = i18n.language === 'ar';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleNavClick = (id: string) => {
    if (isHome) {
      scrollToSection(id);
    } else {
      window.location.href = `/#${id}`;
    }
  };

  const navItems = [
    { label: t('home'), id: 'home', isRoute: false },
    { label: t('services'), id: 'services', isRoute: false },
    { label: t('projects'), id: 'projects', isRoute: false },
    { label: t('whatWeDo'), id: 'what-we-do', isRoute: false },
    { label: t('faq'), id: 'faq', isRoute: false },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || !isHome ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/c83f6350fa782ce29b612b38d2cee1d4/3b7550d6c06eea93242f62b6efa2ff71.png" 
              alt="Debug Logo" 
              className="h-10 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isScrolled || !isHome ? 'text-gray-700 hover:text-[rgb(0,0,139)]' : 'text-white hover:text-gray-200'
                }`}
              >
                {item.label}
              </button>
            ))}
            <Link
              to="/blog"
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled || !isHome ? 'text-gray-700 hover:text-[rgb(0,0,139)]' : 'text-white hover:text-gray-200'
              }`}
            >
              {isAr ? 'المدونة' : 'Blog'}
            </Link>
            <LanguageToggle />
            <button 
              onClick={() => handleNavClick('contact')}
              className="bg-[rgb(0,0,139)] text-white px-6 py-2 rounded-lg font-semibold hover:bg-[rgb(0,0,100)] transition-all cursor-pointer whitespace-nowrap"
            >
              {t('contact')}
            </button>
          </div>

          <div className="md:hidden flex items-center gap-3">
            <LanguageToggle />
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2 rounded-lg ${isScrolled || !isHome ? 'text-gray-700' : 'text-white'}`}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
              >
                {item.label}
              </button>
            ))}
            <Link
              to="/blog"
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
            >
              {isAr ? 'المدونة' : 'Blog'}
            </Link>
            <button 
              onClick={() => handleNavClick('contact')}
              className="block w-full bg-[rgb(0,0,139)] text-white px-4 py-2 rounded-lg font-semibold hover:bg-[rgb(0,0,100)] transition-all cursor-pointer text-center whitespace-nowrap"
            >
              {t('contact')}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}